// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*export const environment = {
  production: false
};*/

export const environment = {
  production: false,
  url_api: 'https://zushilab-backend-6a598136c0d6.herokuapp.com/api/v1',
  bank_list: [{"name":"Mercantil Banco Universal", "code": "0105"},{"name":"Banco de Venezuela", "code": "0102"},{"name":"Banco Venezolano de Crédito", "code": "0104"},{"name":"Banco Provincial", "code": "0108"},{"name":"Banco del Caribe", "code": "0114"},{"name":"Banco Exterior", "code": "0115"},{"name":"Banco Caroní", "code": "0128"},{"name":"Banesco Banco Universal", "code": "0134"},{"name":"Banco Sofitasa", "code": "0137"},{"name":"Banco Plaza", "code": "0138"},{"name":"Banco Fondo Común", "code": "0151"},{"name":"100% Banco", "code": "0156"},{"name":"Del Sur Banco Universal", "code": "0157"},{"name":"Banco del Tesoro", "code": "0163"},{"name":"Banco Agrícola de Venezuela", "code": "0166"},{"name":"Bancrecer", "code": "0168"},{"name":"Mi banco (R4)", "code": "0169"},{"name":"Banco Activo", "code": "0171"},{"name":"Bancamiga Banco Universal", "code": "0172"},{"name":"Banplus Banco Universal", "code": "0174"},{"name":"Banco Bicentenario Banco Universal", "code": "0175"},{"name":"Banco De La Fuerza Armada Nacional Bolivariana", "code": "0177"},{"name":"Banco Nacional de Crédito", "code": "0191"}],
  titleEcommerce: "Zushi Lab",
  ecommerceStatics: "Zushi Lab",
  titlePdf: "ZUSHI LAB",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
